import React, {useCallback, useEffect, useRef, useState} from 'react';
import Text from '../../../../../components/Text/Text';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/redux';
import {RootState} from '../../../../../app/store';
import {useForm} from 'react-hook-form';
import Button from '../../../../../components/Button/Button';
import {HttpClientError, RequestStatus} from "../../../../../http-client";
import {customWarnOption, savedStatusOption} from "../../../../../helpers/alertLabel";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import SelectInput from "../../../../../components/SelectInput/SelectInput";
import {CalcSpecType, CSEmployee, InputAssignCS} from "../models";
import {assignCalcSpec, getCalcSpecSummary, getSingleCalcSpec, reset} from "../calcSpec.reducer";
import {getListByPosition} from "../../../../master/employee/employee.reducer";
import {SingleValue} from "react-select";
import {Option} from "../../../../../components/SelectInput/BasicSelectInput";
import {MdOutlineDeleteForever} from "react-icons/md";
import DatePickerState from "../../../../../components/DatePicker/DatePickerState";
import {isArrayEmpty, isBlank, isObjectEmpty} from "../../../../../helpers/checkEmptiness";
import InputCheckbox from "../../../../../components/Checkbox/InputCheckbox";
import {
    getPoleByJob,
    removeMultiplePoleAssign,
    removePoleAssign,
    reset as resetPole
} from "../../../../basic/pole/pole.reducer";
import {useSelected} from "../../../../../hooks/checkbox/useSelected";
import {useShiftSelected} from "../../../../../hooks/checkbox/useShiftSelected";
import {Pole, PoleAssignmentTypeEnum, PoleGetByJobColumnSort} from "../../../../basic/pole/models";
import AgDataGridStatic from "../../../../../components/DataGrid/AgDataGridStatic";
import {rowNumberRenderer} from "../../../../../components/DataGrid/agGridCustomProps";
import moment from "moment";
import FormLoader from "../../../../../components/Loader/FormLoader";
import {Button as FlowbiteButton} from "flowbite-react";
import {SortingEnum} from "../../../../approval/models";
import {dateSetTimeToNow} from "../../../../../helpers/convert";

const AssignCalcSpec = ({id = undefined}: AssignCalcSpecProps) => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);
    const gridRef = useRef<any>(null);

    const {
        setValue,
        watch,
        reset: resetForm,
        formState: {errors},
    } = useForm<InputAssignCS>({
        defaultValues: {
            employee_id: '',
            employee_name: '',
        }
    });

    const [selectedRemove, setSelectedRemove] = useState<Array<string>>([]);
    const [userAssignCalcSpec, setUserAssignCalcSpec] = useState<Array<CSEmployee>>([]);
    const [dueDate, setDueDate] = useState<Date>(new Date());
    const [selection, setSelection] = useState<Array<string>>([]);
    const [initialPoleIds, setInitialPoleIds] = useState<Array<string>>([]);

    const employeeIdWatcher = watch('employee_id');
    const employeeNameWatcher = watch('employee_name');

    const job = useAppSelector((state: RootState) => state.calcSpec.singleCalcSpec ?? {} as CalcSpecType);
    const calcSpecLoading = useAppSelector((state: RootState) => state.calcSpec.isSingleLoading);
    const isAssignLoading = useAppSelector((state: RootState) => state.calcSpec.isAssignLoading);

    const status = useAppSelector((state: RootState) => state.calcSpec.status);
    const error = useAppSelector((state: RootState) => state.calcSpec.error ?? ({} as HttpClientError));
    const statusPole = useAppSelector((state: RootState) => state.pole.status);
    const errorPole = useAppSelector((state: RootState) => state.pole.error ?? ({} as HttpClientError));
    const employeeOptions = useAppSelector((state: RootState) => state.employee.listByPositionOptions ?? []);
    const isEmployeeLoading = useAppSelector((state: RootState) => state.employee.isLoading);
    const calcSpecSummaryList = useAppSelector((state: RootState) => state.calcSpec.calcSpecSummaryList ?? []);
    const pole = useAppSelector(
        (state: RootState) => state.pole.poleByJob ?? []
    );
    const isPoleLoading = useAppSelector(
        (state: RootState) => state.pole.isLoading
    );

    const {selected, change, clear} = useSelected([] as Array<string>);
    const onChange = useShiftSelected(initialPoleIds, change);

    useEffect(() => {
        dispatch(getListByPosition({skip: 0, take: 1000, position: 'CSQ,Freelance'}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (id !== undefined) {
            dispatch(getSingleCalcSpec({id: id}));
            dispatch(getCalcSpecSummary(id));
        }
    }, [id]);

    useEffect(() => {
        if (!isObjectEmpty(job)) {
            dispatch(getPoleByJob({job_id: job.id as string, skip: 0, take: 1000, column: PoleGetByJobColumnSort.index, sort: SortingEnum.Ascending}));
        }
    }, [job]);

    useEffect(() => {
        if (!isObjectEmpty(job) && !isArrayEmpty(pole)) {
            let employeeList: Array<CSEmployee> = job.employee_prep_list ?? [];
            let selectedPoleIds: string[] = [];
            employeeList.map((item: CSEmployee) => {
                selectedPoleIds = [...selectedPoleIds, item.pole_ids ?? ""];
            });
            let _employeeList = pole.map((item: Pole) => {
                const singleEmployee = employeeList.find((employee: CSEmployee) => employee.pole_ids === item.id) ?? {} as CSEmployee;
                return {
                    employee_id: singleEmployee?.employee_id ?? undefined,
                    employee_name: singleEmployee?.employee_name ?? undefined,
                    pole_ids: item.id,
                    pole_sequences: singleEmployee?.pole_sequences ?? undefined,
                    isStatic: isObjectEmpty(singleEmployee)
                }
            });
            setUserAssignCalcSpec(_employeeList);
            setDueDate(job.date_due === "0001-01-01T00:00:00" ? new Date() : new Date(job.date_due));
            setSelection([...selectedPoleIds]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [job, pole]);

    useEffect(() => {
        if (!isArrayEmpty(pole)) {
            const initialPoleIds = pole
                .filter(item => !item.employee_calcspec_id)
                .map(item => item.id);
            setInitialPoleIds(initialPoleIds);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pole]);

    useEffect(() => {
        if (status !== undefined && status !== RequestStatus.pending) {
            MySwal.fire(savedStatusOption(status === RequestStatus.success, error.data?.message)).then(() => {
                if (status === RequestStatus.success) {
                    dispatch(getSingleCalcSpec({id: id}));
                    dispatch(getCalcSpecSummary(id as string));
                    dispatch(getPoleByJob({job_id: job.id as string, skip: 0, take: 1000, column: PoleGetByJobColumnSort.index, sort: SortingEnum.Ascending}));
                }
                dispatch(reset());
                resetForm();
                // props.onHide();
                clear();
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, error]);

    useEffect(() => {
        if (statusPole !== undefined && statusPole !== RequestStatus.pending) {
            MySwal.fire(savedStatusOption(statusPole === RequestStatus.success, errorPole.data?.message)).then(() => {
                resetForm();
                if (statusPole === RequestStatus.success) {
                    dispatch(getSingleCalcSpec({id: id}));
                    dispatch(getCalcSpecSummary(id as string));
                    dispatch(getPoleByJob({job_id: job.id as string, skip: 0, take: 1000, column: PoleGetByJobColumnSort.index, sort: SortingEnum.Ascending}));
                }
                dispatch(resetPole());
                setSelectedRemove([]);
                // props.onHide();
                clear();
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusPole, errorPole]);

    const onSaveAssign = () => {
        if (isBlank(employeeIdWatcher) || isArrayEmpty(selected)) return null;
        MySwal.fire(
            customWarnOption(
                'Assign Job',
                'Are you sure? You will not be able to recover this data!',
            )
        ).then((result) => {
            let _ids = selected.map((item) => item);

            let _data = [
                {
                    employee_id: employeeIdWatcher,
                    pole_id_list: _ids,
                }
            ]

            if (result.isConfirmed) {
                dispatch(assignCalcSpec({
                    id: job.id,
                    date_due: dateSetTimeToNow(dueDate?.toISOString()) ?? new Date().toISOString(),
                    data: _data,
                }))
            }
        });
    }

    const onEmployeeChange = (val: SingleValue<Option>) => {
        setValue('employee_id', val?.value ?? '');
        setValue('employee_name', val?.text ?? '');
    };

    const onDelete = (poleId: string) => {
        MySwal.fire(
            customWarnOption(
                'Remove Assign',
                'Are you sure you want to remove this Assign? You will not be able to recover this later!',
            )
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(removePoleAssign({
                    poleId: poleId,
                    type: PoleAssignmentTypeEnum.calspec
                }));
            }
        });
    }

    const ActionCellRender = (props: any) => {

        if (props.data === undefined) {
            return null;
        }

        return (
            <div className="flex align-middle h-[100%]">
                {
                    !props.data?.isStatic &&
                    <>
                        {/*// user.user_id === props.data?.employee_id &&*/}
                        <>
                            <button type="button" onClick={() => onDelete(props.data?.pole_ids ?? "")}>
                                <MdOutlineDeleteForever className="mr-2 text-2xl text-secondary-color"/>
                            </button>
                        </>
                    </>
                }
            </div>

        )
    }

    const [columnDefs, _setColumnDefs] = useState([
        {
            headerName: '#',
            field: 'rowNumber',
            width: 30,
            cellRenderer: rowNumberRenderer, // Use the custom cell renderer
            suppressSizeToFit: true,
            checkboxSelection: (props: any) => props.data.employee_id,
            showDisabledCheckboxes: false,
        },
        {field: 'employee_name', headerName: 'Name', filter: 'agTextColumnFilter'},
        {field: 'pole_sequences', headerName: 'Pole Seq', filter: 'agTextColumnFilter'},
        {
            headerName: 'Actions',
            field: 'actions',
            suppressCellFlash: true,
            cellRenderer: ActionCellRender,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            })
        },
    ]);

    const onCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, poleId: string) => {
        if (isBlank(employeeIdWatcher)) return null;
        onChange(event, poleId);
    }

    const onSelectionChanged = useCallback(() => {
        let selectedRows = gridRef.current.api.getSelectedNodes();
        console.log(selectedRows);
        let _selectedRows = selectedRows
            .filter((item: any) => item.data.employee_id)
            .map((item: any) => item.data.pole_ids);
        setSelectedRemove(_selectedRows);
    }, []);

    const onUnassignHandler = () => {
        const _multipleSelection = selectedRemove.map((item) => {
            return {
                poleId: item,
                type: PoleAssignmentTypeEnum.calspec
            }
        });
        MySwal.fire(
            customWarnOption(
                'Remove Get',
                'Are you sure you want to remove this GET? You will not be able to recover this later!',
            )
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeMultiplePoleAssign(_multipleSelection));
            }
        });
    }

    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <FormLoader isLoading={calcSpecLoading || isPoleLoading} label="Fetching Data ...">
                <form>
                    <div className="flex">
                        <div className="w-1/2">
                            <Text label="Job Number" value={job.number_job} suppressBorder/>
                            <Text label="District" value={job.district_name} suppressBorder/>
                            <DatePickerState
                                label="Due Date"
                                name="date_due"
                                placeholderText="Select Due Date"
                                selected={dueDate}
                                onChange={(date) => {
                                    setDueDate(date ?? new Date());
                                }}
                            />
                        </div>
                        <div className="w-1/2 pt-2">
                            <Text label="Type" value={job.type_name} suppressBorder/>
                            <SelectInput
                                key={`my_unique_select_key__user`}
                                options={employeeOptions}
                                isLoading={isEmployeeLoading}
                                value={{
                                    text: employeeNameWatcher,
                                    label: employeeNameWatcher,
                                    value: employeeIdWatcher
                                } as Option}
                                label="CS"
                                onChange={onEmployeeChange}
                                message={errors.employee_id?.message}
                            />

                        </div>
                    </div>

                    <div className="h-[36vh] my-5 border border-[#dfdfdf] rounded-lg">
                        <div className="h-[40px] bg-[#e7ebe6] rounded-t-lg flex items-center">
                            <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 px-3">
                                Poles
                            </label>
                        </div>
                        <div className="h-[calc(36vh-50px)] overflow-auto">
                            <div className="grid md:grid-cols-4 gap-4 p-3">
                                {
                                    pole.map((item, index) => (
                                        <div key={item.id} className={"flex"}>
                                            <label
                                                className={`mr-2 text-sm font-bold text-gray-900 dark:text-gray-300`}
                                                htmlFor={item.id}
                                            >
                                                {`${index + 1}.`}
                                            </label>
                                            <InputCheckbox
                                                className="my-3"
                                                label={item.seq ?? ""}
                                                id={item.id}
                                                onChange={(event) => {
                                                    onCheckboxChange(event, item.id);
                                                }}
                                                checked={selection.includes(item.id) || selected.includes(item.id)}
                                                picked={userAssignCalcSpec.some(_item => _item.pole_ids === item.id && !_item.isStatic)}
                                                // disabled={selection.includes(item.id) || userAssignCalcSpec.some(_item => _item.pole_ids === item.id && _item.isStatic)}
                                            />
                                        </div>
                                    ))
                                }
                            </div>

                        </div>
                    </div>

                    <div className="h-[36vh] my-5 border border-[#dfdfdf] rounded-lg">
                        <div className="h-[40px] bg-[#e7ebe6] rounded-t-lg flex items-center">
                            <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 px-3">
                                Summary
                            </label>
                        </div>
                        <div className="h-[calc(36vh-40px)] overflow-auto">
                            <div className="flex">
                                <div className="w-1/2 overflow-auto h-[calc(36vh-40px)]">
                                    {
                                        calcSpecSummaryList.map((item) => (
                                            <div
                                                className="flex h-[40px] p-4 items-center text-xs border border-[#dfdfdf] hover:bg-[#fcebe0]">
                                                <div className="w-1/3 truncate">
                                                    <b>{item.employee_name}</b>
                                                </div>
                                                <div className="w-1/3">
                                                    <span className="text-[#919191]">Total Poles </span>
                                                    <b>{item.total}</b>
                                                </div>
                                                <div className="w-1/3">
                                                    <span
                                                        className="text-[#919191]">Date </span><b>{moment(item.date_due).format("D MMM YYYY")}</b>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className="w-1/2 h-[calc(36vh-40px)]">
                                    <AgDataGridStatic ref={gridRef} columnDefs={columnDefs} rowData={userAssignCalcSpec}
                                                      tableDimension={{
                                                          width: '100%',
                                                          height: '100%'
                                                      }} containerClass={"h-[calc(36vh-96px)]"} defaultColDef={{
                                        sortable: true,
                                        resizable: true,
                                        flex: 1,
                                        minWidth: 50,
                                        wrapHeaderText: true,
                                        wrapText: true,
                                        autoHeight: true
                                    }} isRowSelectable={() => true} onSelectionChanged={onSelectionChanged}
                                                      isCustomHeader={true} customChildHeaderComponent={
                                        <>
                                            <FlowbiteButton
                                                onClick={onUnassignHandler}
                                                size="xs"
                                                color="success"
                                                disabled={selectedRemove.length === 0}
                                            >
                                                <MdOutlineDeleteForever className="mr-2 h-5 w-5"/>
                                                Unassign Selected ({selectedRemove.length})
                                            </FlowbiteButton>
                                        </>
                                    }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <Button
                            color="success"
                            type="button"
                            title="Submit"
                            isLoading={isAssignLoading}
                            onClick={onSaveAssign}
                        />
                    </div>
                </form>
            </FormLoader>
        </div>
    );
};

export interface AssignCalcSpecProps {
    // job: CalcSpecType;
    id?: string;
    onHide: () => void;
    isLoading?: boolean;
}

export default AssignCalcSpec;
